import React, { useContext } from 'react';
import { MyContext } from '../../context';

function Privacy() {
  const { pageData } = useContext(MyContext);

  return (
    <section className="commonConditions">
      <div className="container">
        <div className="smallContainer">
          <h1>{pageData?.privacyData?.header} </h1>
          {pageData?.privacyData?.contentArray?.map((content, index) => (
            <div style={{ marginTop: '20px' }}>
              <h2>{content?.subHeader}</h2>
              <p style={{ paddingTop: '0px' }}>{content?.subContent}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Privacy;
